import type {GroupBase} from "react-select";

import type {IOption} from "../types/IOption";

export const isSelectOption = <Value, Option extends IOption<Value>, Group extends GroupBase<Option> = GroupBase<Option>>(
    optionOrGroup: Option | Group
): optionOrGroup is Option => {
    return Object.prototype.hasOwnProperty.call(optionOrGroup, "value");
};
